<lms-dynamic-form
  #itineraryTransForm
  [action]="itinerary ? 'training.itineraries.edit' : 'training.itineraries.create'"
  [options]="{
    submitLabel: itinerary ? 'actions.saveChanges' : 'actions.createItinerary',
    disableCard: true,
    enableGridColCard: true
  }"
  [questions]="questions"
  (submit)="submit($event)"
>
  <gl-button
    color-secondary
    text="{{ 'actions.cancel' | translate }}"
    (onClick)="cancel.emit()"
    form-actions-before
  ></gl-button>
</lms-dynamic-form>
